import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import { FC, useState } from 'react'
import { Controller } from 'react-hook-form'
import { MUISelectModal } from '../../../Models'
import { ClearIcon } from '@mui/x-date-pickers'

const transform = (value: any) => {
  if (typeof value === 'boolean') return value
  if (value === 'true') return true
  if (value === 'false') return false
  return Boolean(value)
}

const MUISelect: FC<MUISelectModal> = ({
  options = [],
  error,
  lable,
  name,
  control,
  rules,
  labelKey = 'label',
  valueKey = 'value',
  required = false,
  disabled = false,
  defaultValueIndex = Number.NaN,
  noClear = false,
  transformToBoolean = false,
  onChange,
}) => {
  const notClearable =
    options.length === 2 &&
    options.some((option) => option.value === 'ACTIVE') &&
    options.some((option) => option.value === 'INACTIVE')

  const [showClear, setShowClear] = useState(false)

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => {
        return (
          <FormControl
            className='c-select'
            fullWidth
            data-testid='select-control'
            error={!!error?.[name]}
            sx={{ textAlign: 'left', position: 'relative' }}
            onMouseEnter={() => setShowClear(true)}
            onMouseLeave={() => setShowClear(false)}
          >
            <div className='select-wrapper'>
              <InputLabel
                id='demo-simple-select-label'
                style={disabled ? { color: '#00000061' } : {}}
              >
                <span>
                  {lable}
                  {required && <span style={{ color: '#D4351C' }}>*</span>}
                </span>
              </InputLabel>
              <Select
                className='c-select-menu-item'
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                data-testid={lable}
                label={
                  <span>
                    {lable}
                    {required && <span style={{ color: '#D4351C' }}>*</span>}
                  </span>
                }
                inputProps={{ id: name }}
                {...field}
                onClose={() => setShowClear(false)}
                onChange={(e) => {
                  const selectedOption = options.find((data) => e.target.value === data.key)
                  Object.defineProperty(e, 'selectedOption', {
                    value: selectedOption,
                    writable: false, // Ensure it's read-only
                    configurable: true, // Allows for deletion if needed
                    enumerable: true,
                  })
                  const transformedValue = transformToBoolean
                    ? transform(e.target.value)
                    : e.target.value
                  field.onChange({
                    ...e,
                    target: {
                      ...e.target,
                      value: transformedValue,
                    },
                  })
                  if (onChange)
                    onChange({
                      ...e,
                      target: {
                        ...e.target,
                        value: transformedValue,
                      },
                    })
                }}
                value={field.value?.[0]?.key || field.value?.toString() || ''}
                defaultValue={options?.length > 0 ? options?.[defaultValueIndex]?.value : ''}
                IconComponent={KeyboardArrowDownIcon}
                disabled={disabled}
              >
                {options?.length > 0 &&
                  options?.map((item: any) => {
                    return (
                      <MenuItem
                        key={`${item[valueKey]}_${item[labelKey]}`}
                        value={item[valueKey]}
                        disabled={item.disabled}
                      >
                        {item[labelKey]}
                      </MenuItem>
                    )
                  })}
              </Select>
              {field.value &&
                (typeof field?.value === 'number' || field.value?.length > 0) &&
                !noClear &&
                !notClearable &&
                showClear &&
                !disabled && (
                  <IconButton
                    data-testid='clear-select'
                    size='small'
                    onClick={() => {
                      onChange?.({
                        target: {
                          name,
                          value: '',
                        },
                      })
                    }}
                    sx={{
                      position: 'absolute',
                      right: '1.5rem',
                      top: '50%',
                      transform: 'translateY(-50%)',
                    }}
                  >
                    <ClearIcon sx={{ height: '1rem', width: '1rem' }} />
                  </IconButton>
                )}
            </div>
            <FormHelperText>{error?.[name]?.message as string}</FormHelperText>
          </FormControl>
        )
      }}
    />
  )
}
export default MUISelect
